export const DEFAULT_WEIGHT_UNIT = "kg";

export const formatWeight = (value, unit, placeholder = "") =>
	value != null ? `${value} ${unit || DEFAULT_WEIGHT_UNIT}` : placeholder;
